'use strict';

import NotificationBar from '../NotificationBar/NotificationBar';
import template from './templates/BlockedUserNotificationBar.hbs';
import {userService} from '../../services/CartUserService'


export default class BlockedUserNotificationBar extends NotificationBar {

  initialize() {
    this.template = template;
    super.initialize();
  }

  static shouldDisplay(userData) {
    return userData && userData.blocked;
  }
}

/**
 * Create the BlockedUserNotificationBar if needed
 *
 * @param {jQuery} $parent
 */
export function createBlockedUserNotificationBar($parent) {
  userService.getUserInfo().then((userData) => {
    let isBlocked = BlockedUserNotificationBar.shouldDisplay(userData);
    let $notificationBar = $parent.find('#BlockedUserNotificationBar');
    if ($notificationBar.length) {
      if (isBlocked) {
        new BlockedUserNotificationBar({el: $notificationBar})
      }
    }
  });
}



// WEBPACK FOOTER //
// ./assets/components/BlockedUserNotificationBar/BlockedUserNotificationBar.js